import { render, staticRenderFns } from "./DuplicateEmailCampaignDialog.vue?vue&type=template&id=e50f01e2"
import script from "./DuplicateEmailCampaignDialog.vue?vue&type=script&lang=js"
export * from "./DuplicateEmailCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports